// src/components/auth/ProtectedRoute.jsx
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppContext } from '../../context/AppContext';

const ProtectedRoute = ({ allowedRoles }) => {
    const { user, isLoading } = useAppContext();
    const location = useLocation();

    if (isLoading) return <div className="text-center py-5"><div className="spinner-border"></div></div>;

    if (!user) return <Navigate to="/login" replace />;

    // CEK STATUS VERIFIKASI DISINI
    if (
        user.role === 'manager' && 
        user.is_verified === false && // Jika is_verified bernilai 0/false di DB
        location.pathname !== '/manager/profile'
    ) {
        return <Navigate to="/manager/profile" replace />;
    }

    if (allowedRoles && !allowedRoles.includes(user.role)) {
        return <Navigate to="/unauthorized" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;